<div class="primary-back p-v-6 text-align-justify" fxLayoutAlign="center start" style="width: 100vw;">
  <button class="tint-white back" mat-icon-button routerLink="/">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="p-6" style="width: 1000px">
    <router-outlet></router-outlet>
  </div>
</div>
